const ImageDashBoardSkeleton = () => {
  return (
    <div className="w-full mb-8">
      <div className="flex w-full h-[534px] sm:h-[310px] md:h-[300px] rounded-lg gap-3">
        <div className="w-full object-cover h-full bg-gray-300 rounded-3xl" />
      </div>
    </div>
  );
};

export default ImageDashBoardSkeleton;
